import { Stack, Tooltip, Typography } from "@mui/material";
import type { DocumentCollectionDeliveryProgress } from "../../../../api/types/documentCollectionTypes";

import DocumentIcon from "@mui/icons-material/DescriptionOutlined";
import MailIcon from "@mui/icons-material/MailOutlined";

interface Props {
  documentsCount: number;
  deliveryProgress: DocumentCollectionDeliveryProgress;
}

const DeliveryProgress = ({ documentsCount, deliveryProgress }: Props) => {
  const { emailsCreated, emailsNotDelivered } = deliveryProgress;

  return (
    <Stack direction="row" spacing={2.5} sx={{ px: 1 }}>
      <Tooltip title="All Documents" arrow>
        <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
          <DocumentIcon color="secondary" />
          <Typography>{documentsCount}</Typography>
        </Stack>
      </Tooltip>
      <Tooltip title={emailsCreated ? "All Emails / Not Delivered Emails" : "No Emails"} arrow>
        <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
          <MailIcon color="secondary" />
          {emailsCreated ? (
            <Stack direction="row">
              <Typography>{emailsCreated}&nbsp;/&nbsp;</Typography>
              <Typography color={emailsNotDelivered > 0 ? "error" : "textPrimary"}>{emailsNotDelivered}</Typography>
            </Stack>
          ) : (
            <Typography>-</Typography>
          )}
        </Stack>
      </Tooltip>
    </Stack>
  );
};

export default DeliveryProgress;
